export default "__VITE_ASSET__DHFVqeXC__"